import { COUNTRY_CALLING_CODES, isoToFlagEmoji } from "../data/countryCallingCodes";

type Props = {
  dialCode: string;
  national: string;
  onDialCodeChange: (dialCode: string) => void;
  onNationalChange: (national: string) => void;
  invalid?: boolean;
  disabled?: boolean;
  placeholder?: string;
};

const BORDER = { valid: "#D1E2DD", invalid: "#F87171" };

/** Numéro de téléphone en deux champs : sélecteur de code pays (recherchable au clavier) + numéro local (chiffres uniquement). */
export default function CountryPhoneInput({
  dialCode,
  national,
  onDialCodeChange,
  onNationalChange,
  invalid,
  disabled,
  placeholder = "01 23 45 67 89",
}: Props) {
  const borderColor = invalid ? BORDER.invalid : BORDER.valid;

  return (
    <div className="flex gap-2">
      <select
        value={dialCode}
        onChange={(e) => onDialCodeChange(e.target.value)}
        disabled={disabled}
        className="h-14 rounded-[10px] border-2 bg-white px-2 text-base shrink-0 w-[6.5rem] disabled:opacity-60"
        style={{ borderColor: BORDER.valid }}
      >
        {COUNTRY_CALLING_CODES.map((c) => (
          <option key={c.iso2} value={c.dialCode}>
            {isoToFlagEmoji(c.iso2)} +{c.dialCode}
          </option>
        ))}
      </select>
      <input
        inputMode="numeric"
        placeholder={placeholder}
        value={national}
        onChange={(e) => onNationalChange(e.target.value.replace(/\D/g, ""))}
        disabled={disabled}
        aria-invalid={invalid}
        className="w-full h-14 rounded-[10px] border-2 px-3 text-base disabled:opacity-60"
        style={{ borderColor }}
      />
    </div>
  );
}
